import { ContactDetailsSection } from "../ContactDetailsSidebarContent";

const VALID_CONTACT_DETAILS_SECTIONS: ContactDetailsSection[] = [
  "Information",
  "Files",
  "Encounters",
  "Medications",
  "Content",
  "Payment",
  "Orders",
  "Forms",
  "Eligibility",
  "RelatedContacts",
  "Timeline",
  "Events",
  "Tickets",
  "Vitals",
];

export const convertStringToContactDetailsSection = (str: string): ContactDetailsSection | undefined => {
  const match = VALID_CONTACT_DETAILS_SECTIONS.find((val) => val.toLowerCase() === str.toLowerCase());
  return match;
};
